<template>
  <section class="things-roles things-rights">
    <header class="right-header">
      <h2 class="title-rights">{{rolesLength}} {{labelUsers}}</h2>
      <div class="header-right" v-if="thing.permission_level === 4">
        <button type="button"
                @click="showControlPopup"
                class="btn btn-transparent_blue">
          {{$t('btns.things.thingsControl')}}
        </button>
        <button type="button"
                v-if="checkedUsers.length > 0 && thing.permission_level === 4"
                @click="checkDel"
                class="control-btn-new hover-blue-new hint-cont">
          <del-icon></del-icon>
        </button>
      </div>
    </header>

    <table-component :legend="createLegendRoles()"
                     :clear-checked="clearMarker"
                     :class-name="'users-item users-item_roles'"
                     :column-width="columnWidthRoles"
                     :all-checked="allChecked"
                     :columns="columnsRoles"
                     @changeCheckbox="checkedUsers = $event"
                     @filterName="filterName($event, 'legendRoles')"
                     @filterMail="filterMail($event, 'legendRoles')"
                     @filterRights="filterRights($event, 'legendRoles')"
                     @checkAll="checkAll"></table-component>
  </section>
</template>

<script>
  import {thingRightsControl} from "../../../../mixins/things/thingRightsControls";

  export default {
    name: 'thingsRoles',
    mixins: [thingRightsControl],
    computed: {
      thingUsers() {
        let arr = this.thing.permissions.filter(item => {
          // return item.role.name !== 'Администратор'
          return true;
        });

        // if (this.nameFiltered) {
        //   arr = arr.sort((a,b) => {
        //     let nameA = a.role.name;
        //     if (nameA == null) {
        //       nameA = ' '
        //     };
        //     let nameB = b.role.name;
        //     if (nameB == null) {
        //       nameB = ' '
        //     }

        //     if (this.nameUp) {
        //       if (nameA < nameB) return 1;
        //       if (nameA > nameB) return -1;
        //       return 0
        //     };

        //     if (this.nameDown) {
        //       if (nameA > nameB) return 1;
        //       if (nameA < nameB) return -1;
        //       return 0;
        //     }
        //   });
        //   return arr
        // };
        //
        // if (this.mailFiltered) {
        //   arr = arr.sort((a,b) => {
        //     let nameA = a.role.owner.contacts.email;
        //     let nameB = b.role.owner.contacts.email;
        //
        //     if (this.mailUp) {
        //       if (nameA < nameB) return 1;
        //       if (nameA > nameB) return -1;
        //       return 0
        //     };
        //
        //     if (this.mailDown) {
        //       if (nameA > nameB) return 1;
        //       if (nameA < nameB) return -1;
        //       return 0;
        //     }
        //   });
        //   return arr
        // };
        //
        // if (this.rightsFiltered) {
        //   arr = arr.sort((a,b) => {
        //     let nameA = a.value;
        //     let nameB = b.value;

        //     if (this.rightsUp) {
        //       if (nameA < nameB) return 1;
        //       if (nameA > nameB) return -1;
        //       return 0
        //     };

        //     if (this.rightDown) {
        //       if (nameA > nameB) return 1;
        //       if (nameA < nameB) return -1;
        //       return 0;
        //     }
        //   });
        //   return arr
        // };

        return arr;
      },
      labelUsers() {
        let users = this.rolesLength;
        users = String(users).slice(-1);

        if (users == 0 || users >= 5) {
          return this.$t('things.role0')
        };

        if (users == 1) {
          return this.$t('things.role1')
        };

        if (users > 1 && users < 5) {
          return this.$t('things.role2')
        };
      }
    },
    methods: {
      showControlPopup() {
        this.showOverlay(true);
        this.setDefaultRight(this.checkedUsers);
        this.setRightsType('role');
        this.showRightsControl(true);

      },
      checkDel() {
        let string = '';
        this.checkedUsers.forEach((item) => {
          string += `${item.name}, `
          // string += `${item.role_id}, `
        });
        string = string.slice(0,-2);

        this.showOverlay(true);
        this.showDelPopup(true);
        this.setDelItems(string);
      },
      async deleteItems() {
        let data = { ids: [] };
        let ids = [];
        this.showLoader();

        this.checkedUsers.forEach((checkedUser) => {
          this.thingUsers.forEach((thingUser) => {
            if (checkedUser.id === thingUser.role_id) {
              ids.push(thingUser.id)
            }
          })
        })
        ids.forEach((item, index) => {
          if (index === 0) {
            data.ids = item
          } else {
            data.ids = `${data.ids}, ${item}`
          }
        })
        this.removePermission({data}).then(res => {
          this.getProjects();
        });



        // let roles = this.checkedUsers.map(item => {
        //   return item.id
        // }).join(',');
        // // let data = {
        // //  // access_token: this.token,
        // //   device_id: this.thing.id,
        // //   object_name: 'device',
        // //   value: -1,
        // //   roles_ids: roles
        // // };
        // let data = {
        //   id: roles
        // };
        //
        // await this.removePermission({data, token: this.token});

        this.clearMarker = true;
        this.checkedUsers = [];
        this.clearMarker = false;
        this.hideLoader();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .right-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    margin-bottom: 10px;
    min-height: 40px;
  }

  .title-rights {
    font-family: $msb;
    font-size: 14px;
    letter-spacing: .25px;
  }

  .header-right {
    display: flex;
    align-items: center;

    .btn {
      height: 40px;
      padding: 0 15px;
      font-size: $mm;
    }

    .control-btn {
      min-width: 40px;
      margin-left: 20px;
    }
  }

  .right-item {
    display: flex;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid $grey;
    font-family: $mm;
    font-size: 14px;
    letter-spacing: .25px;
    transition: $anim;

    &:hover {
      background: white;
      box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);
    }
  }

  .right-item_checked {
    background: rgba(215, 227, 234, .5);
  }

  .cell1 {
    width: 26px;
  }

  //782
  .cell2 {
    width: (347 + 308)/782*100%;
    padding: 0 15px;
    display: flex;
    align-items: center;
  }


  .cell4 {
    width: 127/782*100%;
  }

  .legend {
    display: flex;
    align-items: center;
    font-family: $mr;
    font-size: 13px;
    user-select: none;
    cursor: pointer;
    background: none;

    span {
      opacity: .5;
    }

    svg {
      margin-left: 5px;
      cursor: pointer;
    }

    &:hover {
      background: none;
      box-shadow: none;
    }
  }

  .legend_active {
    span {
      opacity: 1;
    }
  }

  .avatar-cont {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-repeat: no-repeat;
    background-size: contain;
    margin-right: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(215, 227, 234);

    svg {
      max-width: 12px;
    }
  }

  .btn-transparent_blue {
    margin-right: 20px;
  }
</style>
